'use client';

import { Loader } from '@brahma/components';
export default function Loading() {
  return <Loader show={true} data-sentry-element="Loader" data-sentry-component="Loading" data-sentry-source-file="loading.tsx" />;
}